import type { RosterClass } from '../../modules/roster/api/roster.client';
import { formatDate } from '../../utils/format';

/** Em dash for empty fields — stable table layout. */
export const EMPTY_FIELD = '—';

/** UI row for Classes admin table/filters (roster `RosterClass`). */
export interface ClassesListRow {
  id: string;
  name: string;
  grade: string;
  codeLabel: string;
  academicYearLabel: string;
  statusLabel: string;
  createdAtLabel: string;
  createdAtRaw: string | undefined;
}

/** Roster classes include optional `code`. */
export function mapRosterClassToClassesListRow(c: RosterClass): ClassesListRow {
  const createdRaw = c.created_at;
  return {
    id: c.id,
    name: c.name ?? '',
    grade: c.grade != null && String(c.grade).trim() !== '' ? String(c.grade) : EMPTY_FIELD,
    codeLabel: c.code != null && String(c.code).trim() !== '' ? String(c.code) : EMPTY_FIELD,
    academicYearLabel:
      c.academic_year_key != null && String(c.academic_year_key).trim() !== ''
        ? String(c.academic_year_key)
        : EMPTY_FIELD,
    statusLabel: c.status != null && String(c.status).trim() !== '' ? String(c.status) : EMPTY_FIELD,
    createdAtLabel: createdRaw ? formatDate(createdRaw) : EMPTY_FIELD,
    createdAtRaw: createdRaw,
  };
}
